module.exports = __webpack_public_path__ + "img/icon-shuoshidian@2x.c92a26b2.png";